import React from 'react'

import { eagerImageAttrs } from '/lib/reactutils/utils.js'

export interface ImageProps {
    srcSmall?: [string, number]
    srcMedium?: [string, number]
    srcLarge?: [string, number]
    src: string
    alt: string
    className?: string
    width?: number
    height?: number
    lazyLoad?: boolean
    // for above-the-fold images: eager + high fetch priority, overrides lazyLoad
    priority?: boolean
}

export default function Image({
    srcSmall,
    srcMedium,
    srcLarge,
    src,
    alt,
    className,
    width,
    height,
    lazyLoad = true,
    priority = false
}: ImageProps){
    const renderSource = (src, maxWidth) => {
        return src ? <source srcSet={src[0]} media={`(max-width: ${src[1]}px)`} /> : null
    }

    return (
        <picture>
            {renderSource(srcSmall, srcSmall && srcSmall[1])}
            {renderSource(srcMedium, srcMedium && srcMedium[1])}
            {renderSource(srcLarge, srcLarge && srcLarge[1])}
            <img
                src={src}
                alt={alt}
                title={alt}
                className={className}
                width={width}
                height={height}
                {...(priority ? eagerImageAttrs : { loading: lazyLoad ? 'lazy' : 'eager' })}
            />
        </picture>
    )
}
